/* Staged theme asset. Does not send conversion events or contact Google. */
(() => {
  'use strict';
  if (window.__dcPaidAttributionInstalled) return;
  window.__dcPaidAttributionInstalled = true;
  const key = '__dc_paid_attribution';
  const storageKey = 'dc_paid_attribution_v1';
  const expires = 90 * 86400000;
  let lastSaved;
  let queue = Promise.resolve();
  let landingClick;
  const params = new URLSearchParams(location.search);
  for (const kind of ['gclid', 'gbraid', 'wbraid']) {
    const value = params.get(kind);
    if (value && /^[A-Za-z0-9_-]{10,512}$/.test(value)) {
      landingClick = {kind,value,clickedAt:new Date().toISOString()};
      break;
    }
  }
  const internal = () => window.DecolabMeasurement?.internal || window.DecolabMeasurement?.staff ||
    window.Shopify?.designMode || window.Shopify?.previewMode || params.get('dc_internal') === '1';
  const permitted = () => {
    const privacy = window.Shopify?.customerPrivacy;
    const consent = privacy?.currentVisitorConsent();
    return !internal() && consent?.marketing === 'yes' && consent?.analytics === 'yes' &&
      privacy.marketingAllowed() && privacy.analyticsProcessingAllowed();
  };
  async function sync() {
    const allowed = permitted();
    let saved;
    try { saved = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch { /* No persistent attribution available. */ }
    let attribution = null;
    if (allowed) {
      const click = landingClick || saved;
      if (click && Number.isFinite(Date.parse(click.clickedAt)) && Date.now() - Date.parse(click.clickedAt) < expires) {
        attribution = {v:1,kind:click.kind,value:click.value,clickedAt:click.clickedAt,
          consentAt: saved?.value === click.value ? saved.consentAt : new Date().toISOString(),marketing:true,adUserData:true};
      }
    }
    try {
      if (attribution) localStorage.setItem(storageKey, JSON.stringify(attribution));
      else localStorage.removeItem(storageKey);
    } catch { /* Cart write can still work without localStorage. */ }
    const value = attribution ? JSON.stringify(attribution) : '';
    // Clear attribution on withdrawal, including attributes surviving from earlier visits.
    if (lastSaved === value) return;
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/update.js`, {method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[key]:value}}),keepalive:true});
    if (response.ok) lastSaved = value;
  }
  function enqueue() { queue = queue.then(sync).catch(() => { /* Never block shopping on analytics failure. */ }); }
  document.addEventListener('visitorConsentCollected', enqueue);
  window.addEventListener('pageshow', enqueue);
  if (window.Shopify?.customerPrivacy) enqueue();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) enqueue();});
})();
